export const StatusChangeConfirmModalStyles = (theme) => ({
  width: '396px',
  margin: '0px auto',
  '& h6': {
    fontSize: '20px',
    color: theme.palette.navy.main,
    // Theme h6 is Title Case (capitalize). Figma headings are Sentence Case.
    textTransform: 'none',
  },
  '& .modal-body': {
    color: 'var(--grey-110)',
    padding: '0px 24px 20px',
    whiteSpace: 'pre-wrap',
  },
  '& .modal-footer': {
    justifyContent: 'flex-end !important',
  },
  '& .modal-footer div': {
    flexFlow: 'row-reverse',
    '& button:nth-child(1)': {
      marginLeft: '10px',
    },
  },
});

export const getStatusChangeConfirmWrapperStyles = (isWarning) => ({
  height: 'auto',
  ...(isWarning
    ? {
        '&.confirmation .header-icon': {
          backgroundColor: 'var(--yellow-main, #FFC800)',
          '& svg': {
            color: 'var(--navy-main, #061E44)',
            backgroundColor: 'transparent',
          },
        },
      }
    : {}),
});
